module.exports = __webpack_public_path__ + "static/media/Madfit_Website_03.f8a1ad57.jpg";